import Vue from 'vue';
import App from './App.vue';
import router from './router/index';
import store from './store/index';

// 重置样式
import "@/assets/style/reset.css"
// 进度条
import 'nprogress/nprogress.css';
// iview主题样式
import '@/assets/style/iview/theme.less';
// 自定义全局样式
import '@/assets/style/global/index.less';

import 'animate.css';
import PAGE_API from '@/apis/pageApi';
import HTTP_API from '@/apis/httpApi';

import pc from "@/utils/pc.ts"

import iView from 'view-design';
import fn from '@/utils/fn.ts';
import Component from 'vue-class-component';
import QRCode from 'qrcodejs2';  // 二维码
import VueContextMenu from '@xunlei/vue-context-menu'

// 全局登录组件
Component.registerHooks([
    'beforeRouteEnter',
    'beforeRouteLeave',
    'beforeRouteUpdate',
]);

import preventReClick from "@/utils/preventRepeatClick.js"

// iview全局使用
Vue.use(iView, {
    transfer: true,
    // size: 'large',
});
// prop全局
Vue.prototype.$fn = fn;
Vue.prototype.$pc = pc;
Vue.prototype.$PAGE_API = PAGE_API
Vue.prototype.$HTTP_API = HTTP_API

Vue.config.productionTip = false;
Vue.prototype.QRCode = QRCode;
Vue.use(VueContextMenu)
Vue.use(preventReClick)

window.App = new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount('#app');
